import { render } from "./PaymentStatus.vue?vue&type=template&id=619b7333&scoped=true&ts=true"
import script from "./PaymentStatus.vue?vue&type=script&lang=ts"
export * from "./PaymentStatus.vue?vue&type=script&lang=ts"

import "./PaymentStatus.vue?vue&type=style&index=0&id=619b7333&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619b7333"]])

export default __exports__